module.exports = __webpack_public_path__ + "img/item17.7c1ecb98.png";